var _rect, _g, _rect2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBeneficiosTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 864,
    height: 663,
    viewBox: "0 0 864 663",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 864,
    height: 663
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 864,
    height: 663,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_236)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_134_236)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 864,
    height: 663,
    rx: 20,
    fill: "#1F375B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_134_236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 864,
    height: 663
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 864,
    height: 663,
    rx: 20,
    fill: "#1F375B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_134_236)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_134_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 594.5,
    r: 112.5,
    fill: "url(#paint0_linear_134_236)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M799.826 587.898C814.551 579.417 832.038 577.123 848.452 581.518C864.866 585.913 878.867 596.639 887.384 611.342L899.423 604.392C888.891 586.855 871.893 574.157 852.089 569.033C832.285 563.91 811.261 566.769 793.546 576.997C775.831 587.225 762.842 604.003 757.377 623.715C751.913 643.428 754.41 664.498 764.331 682.387L776.37 675.436C767.891 660.713 765.598 643.228 769.996 626.816C774.393 610.405 785.121 596.409 799.826 587.898V587.898Z",
    fill: "url(#paint1_linear_134_236)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_134_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 821,
    cy: 77,
    r: 184,
    fill: "url(#paint2_linear_134_236)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.2854 75.3018C103.895 60.6665 112.101 40.8334 112.104 20.1544C112.107 -0.524638 103.907 -20.3603 89.3016 -34.9999L79.4722 -25.1706C91.1173 -13.074 97.5518 3.10838 97.3922 19.8985C97.2326 36.6887 90.4918 52.7459 78.6189 64.6189C66.7459 76.4919 50.6886 83.2326 33.8985 83.3922C17.1083 83.5518 0.925716 77.1176 -11.1708 65.4725L-21.0002 75.3018C-6.36338 89.9039 13.4676 98.1044 34.1426 98.1044C54.8176 98.1044 74.6486 89.9039 89.2854 75.3018Z",
    fill: "url(#paint3_linear_134_236)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_134_236",
    x: -84,
    y: -66,
    width: 1032,
    height: 831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_134_236"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_134_236"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_134_236"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.780392 0 0 0 0 0.972549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_134_236",
    result: "effect2_dropShadow_134_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_134_236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_134_236",
    x: -714,
    y: -152,
    width: 1493,
    height: 1493,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_134_236"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_134_236",
    x: 3,
    y: -741,
    width: 1636,
    height: 1636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 317,
    result: "effect1_foregroundBlur_134_236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_236",
    x1: -328.225,
    y1: 1319.03,
    x2: 488.737,
    y2: 944.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_134_236",
    x1: 868.245,
    y1: 485.983,
    x2: 716.413,
    y2: 967.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_134_236",
    x1: 231.014,
    y1: 1262.01,
    x2: 1567.2,
    y2: 649.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_134_236",
    x1: 60.9929,
    y1: -306.683,
    x2: 39.0568,
    y2: 198.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A5FECB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBeneficiosTablet);
export default __webpack_public_path__ + "static/media/back-beneficios-tablet.5cbc100b05f8ce3a59e8f2e18bcd3261.svg";
export { ForwardRef as ReactComponent };